import { TReduxActions } from '../../types/redux';
import { IHouseInfoState } from '../../types/redux/houseInfo';
import { EActionTypes } from '../../actions/houseInfo';

export const initialState: IHouseInfoState = {
  isFetching: false,
  isError: false,
  data: null,
};

export const houseInfoReducer = (state = initialState, action: TReduxActions): IHouseInfoState => {
  switch (action.type) {
    case EActionTypes.GetHouseInfoRequest:
      return {
        ...state,
        isFetching: true,
      };

    case EActionTypes.GetHouseInfoSuccess:
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        isError: false,
      };

    case EActionTypes.GetHouseInfoFailure:
      return {
        ...state,
        isFetching: false,
        isError: true,
        data: null,
      };

    default:
      return state;
  }
};
